import React from "react";

const LOGO_URL = "/pouchkart-logo.png";

/**
 * Brand logo. On dark surfaces (`variant="dark"`) the image is wrapped in a
 * white plate so the original orange-and-blue mark remains legible without
 * being recolored.
 */
export default function Logo({ className = "", variant = "light", height = 44 }) {
  const isDark = variant === "dark";
  return (
    <div
      data-testid="pk-logo"
      className={`flex items-center ${className}`}
    >
      <div
        className={
          isDark
            ? "bg-white border border-white/10 px-3 py-2 inline-flex items-center"
            : "inline-flex items-center"
        }
      >
        <img
          src={LOGO_URL}
          alt="PouchKart — Flexible Packaging Simplified"
          style={{ height: `${height}px`, width: "auto" }}
          className="block select-none"
          draggable={false}
        />
      </div>
    </div>
  );
}
